import { FormDTO, FormElement, FormElementKind, FormType } from '@gearbelt/global';
import { FormProvider, useForm } from 'react-hook-form';

import { IssuesSelectFormElementMock } from './elements/issue-select';
import { FormElementComponent } from './form-element';
import { buildPreviewDefaults } from './form-element-preview.utils';
import type { FormRendererData } from './form-elements-renderer';
import { PREVIEW_ASSET } from './preview-asset';

export function FormElementPreview({ element, formType }: { element: FormElement; formType: FormType }) {
  // Its own form, so typing on the canvas never marks the designer's form as changed.
  const form = useForm<FormRendererData>({ defaultValues: buildPreviewDefaults([element]) });

  if (element.kind === FormElementKind.IssueSelect) {
    return <IssuesSelectFormElementMock element={element} />;
  }

  return (
    <FormProvider {...form}>
      <FormElementComponent element={element} asset={PREVIEW_ASSET} form={{ type: formType } as FormDTO} readonly={false} isPreview hideLabel />
    </FormProvider>
  );
}
